/* ════════════ OXIDE SPARKS + THE CRAB ════════════
   The Rust dossier's atmosphere: oxidation sparks drifting up, and a
   pixel crab scuttling along the bottom edge. Unsafe to remove. */

import { fillBars } from "./statbars";
import { onPage } from "./router";

const REDUCED = matchMedia("(prefers-reduced-motion: reduce)").matches;

function oxide(signal: AbortSignal) {
  const c = document.querySelector<HTMLCanvasElement>("#oxide")!;
  const ctx = c.getContext("2d")!;
  const colors = ["#ff7a3c", "#ffa06b", "#c4541f", "#ff2e88"];

  type Spark = { x: number; y: number; vy: number; vx: number; s: number; col: string; alpha: number };
  let sparks: Spark[] = [];

  const make = (anywhere = false): Spark => ({
    x: Math.random() * c.width,
    y: anywhere ? Math.random() * c.height : c.height + 6,
    vy: 0.2 + Math.random() * 0.5,
    vx: (Math.random() - 0.5) * 0.3,
    s: Math.random() > 0.85 ? 3 : 2,
    col: colors[(Math.random() * colors.length) | 0]!,
    alpha: 0.25 + Math.random() * 0.4,
  });

  /* the crab: a 7x4 pixel sprite, 1 = shell, 2 = dark detail */
  const CRAB = [
    [0, 1, 0, 0, 0, 1, 0],
    [0, 1, 1, 1, 1, 1, 0],
    [1, 1, 2, 1, 2, 1, 1],
    [0, 1, 0, 1, 0, 1, 0],
  ];
  const crab = { x: -40, dir: 1, pause: 0 };
  const PX = 4;

  const drawCrab = () => {
    const baseY = c.height - CRAB.length * PX - 6;
    ctx.globalAlpha = 0.9;
    for (let r = 0; r < CRAB.length; r++) {
      for (let col = 0; col < CRAB[r]!.length; col++) {
        const v = CRAB[r]![col]!;
        if (!v) continue;
        ctx.fillStyle = v === 1 ? "#ff7a3c" : "#0d0703";
        const x = crab.dir > 0 ? crab.x + col * PX : crab.x + (CRAB[r]!.length - 1 - col) * PX;
        ctx.fillRect(x | 0, baseY + r * PX, PX, PX);
      }
    }
  };

  const seed = () => {
    c.width = innerWidth;
    c.height = innerHeight;
    const count = Math.min(50, Math.floor((c.width * c.height) / 32000));
    sparks = Array.from({ length: count }, () => make(true));
  };
  seed();
  addEventListener("resize", seed, { signal });

  const draw = () => {
    ctx.clearRect(0, 0, c.width, c.height);
    for (const s of sparks) {
      ctx.globalAlpha = s.alpha;
      ctx.fillStyle = s.col;
      ctx.fillRect(s.x | 0, s.y | 0, s.s, s.s);
    }
    drawCrab();
    ctx.globalAlpha = 1;
  };

  if (REDUCED) {
    crab.x = c.width * 0.2;
    draw();
    return;
  }
  const tick = () => {
    if (signal.aborted) return;
    for (const s of sparks) {
      s.y -= s.vy;
      s.x += s.vx;
      if (s.y < -4) Object.assign(s, make());
    }
    // the crab scuttles, pauses, scuttles. borrow-checked locomotion.
    if (crab.pause > 0) {
      crab.pause--;
    } else {
      crab.x += crab.dir * 0.8;
      if (Math.random() < 0.004) crab.pause = 60 + Math.random() * 120;
      if (crab.x > c.width + 40) crab.dir = -1;
      if (crab.x < -40) crab.dir = 1;
    }
    draw();
    requestAnimationFrame(tick);
  };
  tick();
}

onPage((signal) => {
  oxide(signal);
  fillBars();
});
